'use client';
import { __resetStyles as vanillaResetStyles } from '@griffel/core';
import { insertionFactory } from './insertionFactory.js';
import { useRenderer } from './RendererContext.js';
import { useTextDirection } from './TextDirectionContext.js';
/**
 * A version of makeResetStyles() that accepts build output as an input and skips all runtime transforms.
 *
 * @internal
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export function __resetStyles(ltrClassName, rtlClassName, cssRules) {
    const getStyles = vanillaResetStyles(ltrClassName, rtlClassName, cssRules, insertionFactory);
    return function useClasses() {
        const dir = useTextDirection();
        const renderer = useRenderer();
        return getStyles({ dir, renderer });
    };
}
//# sourceMappingURL=__resetStyles.js.map